export const API_BASE_URL = "";
  

export const path_url = API_BASE_URL;

export const WORKER_EXTRACTOR_ID = process.env.REACT_APP_WORKER_EXTRACTOR_ID;
export const WORKER_TOKEN = process.env.REACT_APP_WORKER_TOKEN;

export const responseMessages = {
  INVALID_CREDENTIALS: "Invalid credentials. Please try again.",
  "Could not commit JPA transaction; nested exception is javax.persistence.RollbackException: Error while committing the transaction":
    "Failed to save data. Please try again.",
};

export const project_name = "ENTELI-PRO";

const config = {
  API_BASE_URL,
  path_url,
  WORKER_EXTRACTOR_ID,
  WORKER_TOKEN,
  responseMessages,
  project_name,
};

export default config;
